module.exports = __webpack_public_path__ + "8b167c7727eb2c4ea45e34726b2bf106.pdf";